module.exports = __webpack_public_path__ + "static/beaconAnim-0b2c64768f91a8cbc1af44ca3e654e92.mp4";